import util from '../libs/util';
import router from '../router';
import { mapState, mapActions } from 'vuex';
import dateFormat from 'date-fns/format';
import Setting from '../setting';

/**
 * 页面公共混合
 * */
export default {
  data() {
    return {
      grid4: {
        xxl: 4,
        xl: 4,
        lg: 4,
        md: 6,
        sm: 12,
        xs: 24
      },
      grid6: {
        xxl: 6,
        xl: 6,
        lg: 8,
        md: 12,
        sm: 12,
        xs: 24
      },
      grid8: {
        xxl: 8,
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid12: {
        xxl: 12,
        xl: 12,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid16: {
        xxl: 16,
        xl: 16,
        lg: 16,
        md: 24,
        sm: 24,
        xs: 24
      },
      grid18: {
        xxl: 18,
        xl: 18,
        lg: 18,
        md: 24,
        sm: 24,
        xs: 24
      },
      grid24: {
        xxl: 24,
        xl: 24,
        lg: 24,
        md: 24,
        sm: 24,
        xs: 24
      }
    };
  },
  computed: {
    ...mapState('admin/user', ['info']),
    ...mapState('admin/cache', ['userNames', 'enums', 'dicts', 'caches']),
    ...mapState('admin/permission', ['userPermissions']),
    rootPath() {
      return Setting.rootPath;
    },
    sysInfo() {
      return Setting.info;
    },
    layout() {
      return Setting.layout;
    },
    apiBaseURL() {
      return Setting.apiBaseURL;
    },
    uploadURL() {
      return Setting.apiBaseURL + 'api/Attachment/add';
    },
    uploadHeaders() {
      const token = util.cookies.get('token');
      return {
        Authorization: 'Bearer ' + token
      };
    }
  },
  methods: {
    ...mapActions('admin/cache', ['loadEnum', 'loadDict', 'loadUserName', 'loadCache']),
    copy(model) {
      return JSON.parse(JSON.stringify(model));
    },
    allow(key) {
      this.$store.dispatch('admin/permission/load');

      if (key.startsWith('permission/')) {
        // 全局权限
        return this.userPermissions[key];
      } else {
        // 页面权限点
        let url = router.history.current.path.substr(1);

        if (this.userPermissions[url + '$' + key] == true) {
          return true;
        }

        let count = Object.keys(this.userPermissions).filter(item => item.startsWith(url + '$')).length;

        // 未分权限点
        if (this.userPermissions[url] == true && count == 0) {
          return true;
        }

        return false;
      }
    },
    getCache(type, id) {
      this.loadCache(type);
      return this.caches[type].find(x => x.id == id);
    },
    getCacheList(type) {
      this.loadCache(type);
      return this.caches[type];
    },
    getEnum(type, id) {
      this.loadEnum(type);

      if (id == null) {
        return null;
      }

      if (this.layout.showI18n) {
        return this.$t('Enum_' + type + '_' + id);
      } else {
        return this.enums[type][id];
      }
    },
    getEnumList(type) {
      this.loadEnum(type);

      return Object.keys(this.enums[type]).map(key => {
        if (this.layout.showI18n) {
          return {
            id: key,
            name: this.$t('Enum_' + type + '_' + key)
          };
        } else {
          return {
            id: key,
            name: this.enums[type][key]
          };
        }
      });
    },
    getDict(type, id) {
      this.loadDict(type);

      if (id == null) {
        return null;
      }

      if (this.layout.showI18n) {
        return this.$t('Dict_' + type + '_' + id);
      } else {
        return this.dicts[type][id];
      }
    },
    getDictList(type) {
      this.loadDict(type);

      return Object.keys(this.dicts[type]).map(key => {
        if (this.layout.showI18n) {
          return {
            id: key,
            name: this.$t('Dict_' + type + '_' + key)
          };
        } else {
          return {
            id: key,
            name: this.dicts[type][key]
          };
        }
      });
    },
    getUserName(id) {
      this.loadUserName(id);
      return this.userNames[id];
    },
    // 附件
    getAttachmentUrl(file, name) {
      if (file) {
        return this.apiBaseURL + 'api/Attachment/get?file=' + encodeURI(file) + '&name=' + encodeURI(name);
      } else {
        return null;
      }
    },
    // 文件下载
    fileDownload(file, name) {
      let url = this.getAttachmentUrl(file, name);

      if (url) {
        window.location.href = url;
      }
    },
    // 图片路径
    getImgUrl(file) {
      if (file) {
        return this.apiBaseURL + 'api/Attachment/getImage?file=' + encodeURI(file);
      } else {
        return this.rootPath + 'images/no-image.png';
      }
    },
    // 显示格式化内容
    showData(model, column) {
      let expression = column.code;
      let dataType = column.dataType;
      let format = column.displayFormat;
      let digit = column.digit;
      let fixedDigit = column.fixedDigit;

      if (!dataType) {
        return null;
      }

      let value = this.parseData(model, expression);

      if (value == null) {
        return null;
      }

      if (dataType.indexOf('Enum:') === 0) {
        return this.getEnum(dataType.replace('Enum:', ''), value);
      } else if (dataType === 'BigInteger') {
        if (format == 'User') {
          return this.getUserName(value);
        } else {
          return value;
        }
      } else if (dataType === 'DateTime') {
        // 日期
        if (!!(format || '').trim()) {
          return dateFormat(new Date(value), format);
          // return $filter('date')(value, format);
        } else {
          return dateFormat(new Date(value), 'yyyy-MM-dd');
          // return $filter('date')(value, 'yyyy-MM-dd');
        }
      } else if (dataType === 'Decimal' || dataType === 'Float' || dataType === 'Double') {
        value = parseFloat(value);

        // 千分位
        if (format === 'Money') {
          return this.formatThousand(value.toFixed(2));
        } else if (format === 'Thousand') {
          return this.formatThousand(this.keepDecimal(value, digit, fixedDigit));
        } else if (format === 'Percent') {
          return this.keepDecimal(value, digit, fixedDigit) + '%';
        } else {
          return this.keepDecimal(value, digit, fixedDigit);
        }
      } else if (dataType === 'Boolean') {
        if (format === 'Y') {
          return value ? '<i class="fa fa-check info"></i>' : '';
        } else if (format === 'YN') {
          return value ? '<i class="fa fa-check"></i>' : '<i class="fa fa-times"></i>';
        } else if (format === 'Disabled') {
          return value ? '<i class="fa fa-ban error"></i>' : '';
        } else if (format === 'Valid') {
          return value ? '<i class="fa fa-check success"></i>' : '';
        } else if (format === 'Attention') {
          return value ? '<i class="fa fa-exclamation error"></i>' : '';
        } else {
          return value ? '<i class="fa fa-check info"></i>' : '';
        }
      } else if (dataType === 'String') {
        if (this.layout.showI18n) {
          return this.tParam(value);
        } else {
          return value;
        }
      } else {
        return value;
      }
    },
    // 根据表达式取值
    parseData(model, expression) {
      if (expression == null) {
        return null;
      }

      let keys = expression.split('.');
      let result = model;

      for (let i = 0; i < keys.length; i++) {
        if (result == null) {
          return null;
        }
        result = result[keys[i]];
      }

      return result;
    },
    // 根据表达式赋值
    setData(model, expression, value) {
      if (expression == null) {
        return;
      }

      let keys = expression.split('.');
      let target = model;

      for (let i = 0; i < keys.length; i++) {
        if (i === keys.length - 1) {
          target[keys[i]] = value;
        } else {
          if (!(keys[i] in target) || target[keys[i]] == null) {
            target[keys[i]] = {};
          }

          target = target[keys[i]];
        }
      }

      this.$forceUpdate();
    },
    // 根据表达式取值(日期)
    parseDateTimeData(model, expression) {
      let data = this.parseData(model, expression);

      if (data == null) {
        return '';
      } else {
        return data;
      }
    },
    // 根据表达式取值(数组)
    parseArrayData(model, expression) {
      let data = [];
      let value = this.parseData(model, expression);

      if (this.isJSON(value)) {
        data = JSON.parse(value);
      }

      return data;
    },
    // 根据表达式赋值(数组)
    setArrayData(model, expression, value) {
      let data = '';
      if (value != null) {
        data = JSON.stringify(value);
      }

      this.setData(model, expression, data);
    },
    // 根据表达式取值(日期段)
    parseDateRangeData(model, expression) {
      let data = [];
      let value = this.parseData(model, expression);

      if (this.isJSON(value)) {
        data = JSON.parse(value);
        data[0] = new Date(data[0]);
        data[1] = new Date(data[1]);
      }

      return data;
    },
    // 根据公式获取触发字段
    getTriggers(text) {
      let triggers = [];
      let expression = '';

      for (let i = 0; i < text.length; i++) {
        if (
          text[i] == ' ' ||
          text[i] == '+' ||
          text[i] == '-' ||
          text[i] == '*' ||
          text[i] == '/' ||
          text[i] == '(' ||
          text[i] == ')' ||
          text[i] == '>' ||
          text[i] == '<' ||
          text[i] == '!' ||
          text[i] == '&' ||
          text[i] == '|' ||
          text[i] == '='
        ) {
          if (!!(expression || '').trim()) {
            triggers.push(expression);
            expression = '';
          }
        } else {
          expression += text[i];
        }
      }

      if (!!(expression || '').trim()) {
        triggers.push(expression);
      }

      return triggers;
    },
    // 计算列
    calculate(text, model) {
      let result = '';
      let expression = '';

      for (let i = 0; i < text.length; i++) {
        if (
          text[i] == ' ' ||
          text[i] == '+' ||
          text[i] == '-' ||
          text[i] == '*' ||
          text[i] == '/' ||
          text[i] == '(' ||
          text[i] == ')' ||
          text[i] == '>' ||
          text[i] == '<' ||
          text[i] == '!' ||
          text[i] == '|' ||
          text[i] == '&' ||
          text[i] == '='
        ) {
          if (!!(expression || '').trim()) {
            if (!isNaN(expression) || expression.substr(0, 1) == "'" || expression.substr(0, 1) == '"' || expression == 'null') {
              result += expression;
            } else {
              let data = this.parseData(model, expression);

              if (data == null) {
                result += expression;
              } else if (isNaN(data)) {
                result += "'" + String(data) + "'";
              } else {
                result += String(data);
              }
            }

            expression = '';
          }
          result += text[i];
        } else {
          expression += text[i];
        }
      }

      if (!!(expression || '').trim()) {
        if (!isNaN(expression) || expression.substr(0, 1) == "'" || expression.substr(0, 1) == '"' || expression == 'null') {
          result += expression;
        } else {
          let data = this.parseData(model, expression);

          if (data == null) {
            result += 'null';
          } else if (isNaN(data)) {
            result += "'" + String(data) + "'";
          } else {
            result += String(data);
          }
        }
      }

      let data = null;
      try {
        console.log('expression', result);
        data = eval(result);

        if (data != 'NaN' && String(data) == 'NaN') {
          data = null;
        } else if (typeof data == 'number' && (String(data) == 'Infinity' || String(data) == '-Infinity')) {
          data = null;
        }
      } catch (e) {
        //console.log('表达式计算错误', e);
      }

      return data;
    },
    // 根据条件判断
    judgeCondition(setting, model) {
      if (!setting) {
        return false;
      }

      if (setting.type == 'Condition') {
        // 条件
        for (let i = 0; i < setting.condition.length; i++) {
          let data = this.parseData(model, setting.condition[i].code);
          if (data == null) {
            data = '';
          }
          let value = setting.condition[i].value;
          if (value == null) {
            value = '';
          }
          let operator = setting.condition[i].operator;
          let result = false;

          if (operator == 'Equal') {
            result = value.split(',').some(item => {
              return String(data) == item;
            });
          } else if (operator == 'Contains') {
            result = value.split(',').some(item => {
              return String(data).indexOf(item) != -1;
            });
          } else if (operator == 'GreaterThan') {
            result = data > value;
          } else if (operator == 'LessThan') {
            result = data < value;
          } else if (operator == 'GreaterThanOrEqual') {
            result = data >= value;
          } else if (operator == 'LessThanOrEqual') {
            result = data <= value;
          } else if (operator == 'NotEqual') {
            result = value.split(',').every(item => {
              return String(data) != item;
            });
          }

          if (!result) {
            return false;
          }
        }
        return true;
      } else if (setting.type == 'Expression') {
        // 表达式
        return this.calculate(setting.expression, model) == true;
      }
    },
    // 确认框
    confirm(title, onConfirm) {
      let swal = this.$swal.fire({
        title: this.tParam(title),
        icon: 'question',
        confirmButtonText: this.$t('Front_Btn_OK'),
        cancelButtonText: this.$t('Front_Btn_Cancel'),
        showCancelButton: true
      });

      swal.then(result => {
        if (result.value) {
          if (typeof onConfirm === 'function') {
            onConfirm();
          }
        }
      });

      return swal;
    },
    // 带输入的确认框
    confirmInput(title, inputLabel, onConfirm, preConfirm) {
      let swal = this.$swal.fire({
        title: this.tParam(title),
        input: 'text',
        confirmButtonText: this.$t('Front_Btn_OK'),
        cancelButtonText: this.$t('Front_Btn_Cancel'),
        inputPlaceholder: inputLabel,
        icon: 'question',
        showCancelButton: true,
        preConfirm: preConfirm
      });

      swal.then(result => {
        if (result.value) {
          if (typeof onConfirm === 'function') {
            onConfirm();
          }
        }
      });

      return swal;
    },
    // 成功提示
    success(message, onConfirm) {
      var swal = this.$swal.fire({
        title: this.tParam(message),
        icon: 'success',
        confirmButtonText: this.$t('Front_Btn_OK')
      });

      swal.then(() => {
        if (typeof onConfirm === 'function') {
          onConfirm();
        }
      });

      return swal;
    },
    // 警告提示
    warning(message, onConfirm) {
      var swal = this.$swal.fire({
        title: this.tParam(message),
        icon: 'warning',
        confirmButtonText: this.$t('Front_Btn_OK')
      });

      swal.then(() => {
        if (typeof onConfirm === 'function') {
          onConfirm();
        }
      });

      return swal;
    },
    // 失败提示
    error(message, onConfirm) {
      var swal = this.$swal.fire({
        title: this.tParam(message),
        icon: 'error',
        confirmButtonText: this.$t('Front_Btn_OK')
      });

      swal.then(() => {
        if (typeof onConfirm === 'function') {
          onConfirm();
        }
      });

      return swal;
    },
    // 获取超链接
    getHyperlink(data, hyperlink) {
      while (hyperlink.indexOf('{') >= 0) {
        let start = hyperlink.indexOf('{');
        let end = hyperlink.indexOf('}');
        let expression = hyperlink.substring(start + 1, end);

        hyperlink = hyperlink.substring(0, start) + this.parseData(data, expression) + hyperlink.substring(end + 1);
      }

      return hyperlink;
    },
    // 保留小数
    keepDecimal(num, digit, fixedDigit) {
      if (digit == null) {
        return num;
      }

      let result = parseFloat(num);
      if (isNaN(result) || isNaN(digit)) {
        return null;
      }

      if (fixedDigit) {
        return result.toFixed(digit);
      } else {
        return Math.round(num * Math.pow(10, digit)) / Math.pow(10, digit);
      }
    },
    // 加千分位
    formatThousand(value) {
      if (value == null) {
        return value;
      }

      let intPart = Math.trunc(value); // 获取整数部分

      let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断
      let value2Array = value.toString().split('.');
      // =2表示数据有小数位
      if (value2Array.length === 2) {
        return intPartFormat + '.' + value2Array[1].toString();
      } else {
        return intPartFormat;
      }
    },
    // 重置通知栏数字
    resetNotice() {
      this.getNotice(this).init();
    },
    // 获取通知栏
    getNotice(node) {
      if (node.$refs.notice != null) {
        return node.$refs.notice;
      }

      if (node.$parent != null) {
        return this.getNotice(node.$parent);
      }

      return null;
    },
    // 判断是否JSON
    isJSON(str) {
      if (!!(str || '').trim()) {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          return false;
        }
      } else {
        return false;
      }
    },
    // 解析多语言带参数
    tParam(str) {
      let array = str.split('|');
      let key = array[0];
      array.shift();

      return this.$t(key, array);
    }
  }
};
